// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select-tour-type .select-tour-type {
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
select-tour-type .select-tour-type input[type=radio] {
  display: none;
}
select-tour-type .select-tour-type button,
select-tour-type .select-tour-type label {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: inherit;
  margin-right: inherit;
  margin-bottom: var(--motes-padding);
  padding: 1rem;
  border: 2px solid var(--motes-white);
  border-radius: 10px;
  box-shadow: var(--shadow-elevation-low);
  transition: 0.3s;
  text-align: left;
  color: var(--motes-black);
  background-color: var(--motes-white);
  pointer-events: initial;
  cursor: pointer;
}
select-tour-type .select-tour-type button {
  height: 60px;
  width: 170px;
}
select-tour-type .select-tour-type label {
  width: 300px;
}
select-tour-type .select-tour-type button:disabled,
select-tour-type .select-tour-type button.defocus,
select-tour-type .select-tour-type input[type=radio]:disabled + label {
  background-color: var(--motes-light-gray);
  border-color: var(--motes-light-gray);
  color: var(--motes-gray);
}
select-tour-type .select-tour-type button:hover:not(.defocus):not(:disabled),
select-tour-type .select-tour-type input[type=radio]:not(:disabled) + label:hover {
  box-shadow: var(--shadow-elevation-medium);
}
select-tour-type .select-tour-type button:disabled,
select-tour-type .select-tour-type input[type=radio]:disabled + label:hover {
  cursor: default;
}
select-tour-type .select-tour-type input[type=radio]:checked + label {
  border-color: var(--motes-light-blue);
}
select-tour-type .select-tour-type .input-icon {
  font-size: 1.5rem;
  margin: auto 1rem auto 0;
}
select-tour-type .select-tour-type button.input-description {
  flex-direction: row;
  justify-content: flex-start;
}
select-tour-type .select-tour-type .input-description {
  font-family: var(--text-font);
  font-size: 0.8rem;
  line-height: 1.2em;
  display: flex;
  flex-direction: column;
}
select-tour-type .select-tour-type .input-description p {
  font-size: inherit;
  line-height: inherit;
  margin: 0;
}
select-tour-type .select-tour-type .input-description h3 {
  font-size: inherit;
  line-height: inherit;
  font-family: inherit;
  font-weight: bold;
  margin: 0;
}
select-tour-type .select-tour-type .input-description h3:first-letter,
select-tour-type .select-tour-type .input-description p:first-letter {
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/editor-page/components/select-tour-type/select-tour-type.component.scss"],"names":[],"mappings":"AACI;EACI,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AAAR;AAEQ;EACI,aAAA;AAAZ;AAGQ;;EAEI,sBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,oBAAA;EACA,qBAAA;EACA,mCAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,uCAAA;EACA,gBAAA;EAEA,gBAAA;EACA,yBAAA;EACA,oCAAA;EACA,uBAAA;EACA,eAAA;AAJZ;AAOQ;EACI,YAAA;EACA,YAAA;AALZ;AAQQ;EACI,YAAA;AANZ;AAUQ;;;EAGI,yCAAA;EACA,qCAAA;EACA,wBAAA;AARZ;AAYQ;;EAEI,0CAAA;AAVZ;AAcQ;;EAEI,eAAA;AAZZ;AAeQ;EACI,qCAAA;AAbZ;AAgBQ;EACI,iBAAA;EACA,wBAAA;AAdZ;AAiBQ;EACI,mBAAA;EACA,2BAAA;AAfZ;AAkBQ;EACI,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAhBZ;AAkBY;EACI,kBAAA;EACA,oBAAA;EACA,SAAA;AAhBhB;AAmBY;EACI,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,iBAAA;EAEA,SAAA;AAlBhB;AAqBY;;EAEI,0BAAA;AAnBhB","sourcesContent":["select-tour-type {\n    .select-tour-type {\n        pointer-events: none;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n\n        input[type=\"radio\"] {\n            display: none;\n        }\n\n        button,\n        label {\n            box-sizing: border-box;\n\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n\n            margin-left: inherit;\n            margin-right: inherit;\n            margin-bottom: var(--motes-padding);\n            padding: 1rem;\n            border: 2px solid var(--motes-white);\n            border-radius: 10px;\n            box-shadow: var(--shadow-elevation-low);\n            transition: 0.3s;\n\n            text-align: left;\n            color: var(--motes-black);\n            background-color: var(--motes-white);\n            pointer-events: initial;\n            cursor: pointer;\n        }\n\n        button {\n            height: 60px;\n            width: 170px;\n        }\n\n        label {\n            width: 300px;\n        }\n\n        // Disabled or defocused button and labels\n        button:disabled,\n        button.defocus,\n        input[type=\"radio\"]:disabled+label {\n            background-color: var(--motes-light-gray);\n            border-color: var(--motes-light-gray);\n            color: var(--motes-gray);\n        }\n\n        // Button and label hover\n        button:hover:not(.defocus):not(:disabled),\n        input[type=\"radio\"]:not(:disabled)+label:hover {\n            box-shadow: var(--shadow-elevation-medium);\n        }\n\n        // Use default cursor (instead of pointer) for disabled inputs\n        button:disabled,\n        input[type=\"radio\"]:disabled+label:hover {\n            cursor: default;\n        }\n\n        input[type=\"radio\"]:checked+label {\n            border-color: var(--motes-light-blue);\n        }\n\n        .input-icon {\n            font-size: 1.5rem;\n            margin: auto 1rem auto 0;\n        }\n\n        button.input-description {\n            flex-direction: row;\n            justify-content: flex-start;\n        }\n\n        .input-description {\n            font-family: var(--text-font);\n            font-size: 0.8rem;\n            line-height: 1.2em;\n            display: flex;\n            flex-direction: column;\n\n            p {\n                font-size: inherit;\n                line-height: inherit;\n                margin: 0;\n            }\n\n            h3 {\n                font-size: inherit;\n                line-height: inherit;\n                font-family: inherit;\n                font-weight: bold;\n\n                margin: 0;\n            }\n\n            h3:first-letter,\n            p:first-letter {\n                text-transform: capitalize;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
